// interface.
import { IRoute } from '@routes/routes';

// types.
import {
  pathOPCDashboard,
  pathOPCList,
  pathOPCAnalytics,
  pathOPCMaxPrice,
} from './routes.types';

// components.
import { Sales } from '../modules/Sales/Sales';
import { OrchestratorList } from '../modules/OrchestratorList/OrchestratorList';
import { AnalyticsOPC } from '../modules/AnalyticsOPC/AnalyticsOPC';
import { MaxPrice } from '../modules/MaxPrice/MaxPrice';

// components.

export const routesOrchestratorPricingCommitteePage: IRoute[] = [
  {
    id: 'dashboard-opc',
    path: `${pathOPCDashboard}`,
    element: <Sales />,
  },
  {
    id: 'analytics-opc',
    path: `${pathOPCAnalytics}`,
    element: <AnalyticsOPC />,
  },
  {
    id: 'list-opc',
    path: `${pathOPCList}`,
    element: <OrchestratorList />,
  },
  {
    id: 'max-price-opc',
    path: `${pathOPCMaxPrice}`,
    element: <MaxPrice />,
  },
];
